import {useState, useEffect, useContext, createContext} from 'react';
import {useAuth} from "./authContext";
import {getUserProfile} from '../network/apis/user.api';

const ProfileContext = createContext();

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({children}) => {
    const {authenticated, token} = useAuth();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const fetchProfile = async () => {
        try {
            setLoading(true);
            const user = await getUserProfile(token);
            setProfile(user);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        if (authenticated && token) {
            fetchProfile();
        } else {
            setProfile(null);
            setLoading(false);
        }
    }, [authenticated, token]);

    return (
        <ProfileContext.Provider value={{profile, loading, error, fetchProfile}}>
            {children}
        </ProfileContext.Provider>
    );
};
